import { ExternalUserAccessControlDto, type ExternalUserAccessControlInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-access-control.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import { entityLikeSchema, entityLikeSchemaUuid } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import type { ProfileFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-find.dto';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';

import * as yup from 'yup';

/** External user create/update request body */
export interface ExternalUserFormInterface {
  /** Profile this external user belongs to */
  profile: ProfileFindInterface;
  /** User job display name */
  job?: string;
  /** If `true` then external user will receive mailings */
  isMailingEnabled?: boolean;
  /** External user access control settings */
  accessControl?: ExternalUserAccessControlInterface;
  /** Client this external user belongs to */
  client: ClientFindInterface;
  /** Related counterparties (mostly need for depds) */
  contragents?: ContragentFindInterface[];
}

/** External user create/update request body - DTO schema */
export const ExternalUserFormDto = SerdeDtoClass.create<ExternalUserFormInterface>(SecurityDtoKeysEnum.EXTERNAL_USER_FORM_DTO, {
  profile: {
    label: 'Профиль',
    checkers: [SecurityBackendValidatorsEnum.PROFILE_ASSERT_EXISTS_BY_DTO],
    serializer: entityLikeSchemaUuid,
  },
  job: {
    optional: true,
    label: 'Должность',
    serializer: yup.string(),
  },
  isMailingEnabled: {
    optional: true,
    default: false,
    label: 'Включать в рассылку',
    serializer: yup.boolean(),
  },
  accessControl: {
    optional: true,
    label: 'Права доступа',
    nested: ExternalUserAccessControlDto,
    serializer: (_, nested) => nested,
  },
  client: {
    label: 'Клиент',
    checkers: [ClientCheckerKeysEnum.CLIENT_ASSERT_EXISTS_BY_DTO],
    serializer: entityLikeSchema,
  },
  contragents: {
    optional: true,
    label: 'Контрагенты',
    checkers: [ClientCheckerKeysEnum.CONTRAGENT_ASSERT_EXISTS_BY_DTO],
    serializer: yup.array(entityLikeSchema),
  },
});
